import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCount } from "./counterAPI";

const API_URL = process.env.REACT_APP_API_URL;

const initialState = {
  value: 0,
  blackBalance : 0,
  loading : true,
  status: "idle",
};


export const getBlackBalanceAsync = createAsyncThunk(
  "api/getblackbalance",
  async(service) => {
      const { data : response } = await service.request.get(`${API_URL}/user/balance`);
      console.log('Service response : ', response.data);
      return response.data.blackBalance;
  }
)

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getBlackBalanceAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBlackBalanceAsync.fulfilled, (state, action) => {
        state.loading = false;
        console.log('Action  : ', action.payload);
        state.blackBalance = action.payload;
      });
  },
});

export const { increment, decrement, incrementByAmount } = counterSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCount = (state) => state.counter.value;
export const selectStatus = (state) => state.counter.status;
export const selectLoadingStatus = (state) => state.counter.loading;
export const selectBlackBalance = (state) => state.counter.blackBalance;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd = (amount) => (dispatch, getState) => {
  const currentValue = selectCount(getState());
  if (currentValue % 2 === 1) {
    dispatch(incrementByAmount(amount));
  }
};

export default counterSlice.reducer;
